import api from 'networkapp-api-connector';
import moment from 'moment';

export default {
    fetchEventVotingSessions: function (eventId) {
        const fetchTime = moment
            .utc(app.store.getState().session.lastUpdate?.events.find(event => event.id == eventId)?.livevoting_updated || '1970-01-01')
            .toISOString();
        return api.voting.fetchEventVotingSessions(eventId).then(sessions => {
            app.store.dispatch(app.actions.voting.updateSessions(eventId, sessions, fetchTime));
            return sessions;
        });
    },
    socket: api.voting.socket,
};
